import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Contract } from '../classes/contract';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class ContractService {
    API_CONTRACT_URL = config.serverAddress + ':' + config.serverPort + '/contract/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_CONTRACT_URL + 'all');
    }
    getAllValidated() {
        return this.http.get(this.API_CONTRACT_URL + 'validated');
    }
    getByID(id: string | null) {
        return this.http.get(this.API_CONTRACT_URL + id);
    }
    getByIDContractFounder(idContractFounder: string) {
        return this.http.get(this.API_CONTRACT_URL + 'contract-founder/' + idContractFounder);
    }
    create(contract: Contract) {
        return this.http.post(this.API_CONTRACT_URL + 'create', contract);
    }
    update(contract: Contract) {
        return this.http.put(this.API_CONTRACT_URL + 'update', contract);
    }
    delete(id: number) {
        return this.http.delete(this.API_CONTRACT_URL + 'delete/' + id);
    }
}
